export function isDirty(v: string | null | undefined): v is string {
  return v !== null && v !== undefined
}
